import React, { useState } from "react";
import { Modal } from "bootstrap";
import useApi from "../utils/useApi";

const ConfirmPasswordModal = ({ show, onClose, onSuccess }) => {
  const { callApi } = useApi();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleConfirm = async () => {
    setLoading(true);
    setError("");

    try {
      const response = await callApi({
        endpoint: "/admin/clients/confirm-admin-password",
        method: "POST",
        data: { password },
      });

      console.log(response);

      if (response.success) {

        onSuccess(); // ✅ If password is valid, execute delete operation
        setPassword("");
        onClose(); // ✅ Close modal
      } else {
        setError(response.message || "Invalid password.");
      }
    } catch (err) {
      console.error(err);

      // ✅ Handle 401 Error (Unauthorized)
      if (err.response && err.response.status === 401) {
        setError(err.response.data.message || "Invalid password."); // Display custom error message
      } else {
        setError(err.message || "An error occurred. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={`modal fade ${show ? "show d-block" : ""}`} tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Confirm Password</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <p>Please provide your password before proceeding</p>
            <input
              type="password"
              className="form-control"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            {error && <small className="text-danger">{error}</small>}
          </div>
          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={onClose} disabled={loading}>
              Cancel
            </button>
            <button className="btn btn-primary" onClick={handleConfirm} disabled={loading || !password}>
              {loading ? "Confirming..." : "Confirm identity"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmPasswordModal;
